import { toast } from "sonner";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function downloadAsset(path, fallbackName, label = "download") {
  const id = toast.loading(`Preparing ${label}…`);
  try {
    const res = await fetch(`${BASE}${path}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const disposition = res.headers.get("content-disposition") || "";
    const match = disposition.match(/filename="?([^"]+)"?/);
    const filename = match ? match[1] : fallbackName;
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
    toast.success(`${label} downloaded`, { id });
  } catch (e) {
    const a = document.createElement("a");
    a.href = `${BASE}${path}`;
    a.target = "_blank";
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    a.remove();
    toast.message(`Opening ${label} in a new tab…`, { id });
  }
}
